// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"1a314ece","903":"40750706","963":"1a314ece"}[chunkId] + ".chunk.css";
};